import { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Api from '../api/api';
import Enums from '../../utilities/enum';
import Pagination from '../shared/pagination';
import Loader from '../shared/loader';
import arrayUtilities from '../../utilities/arrayUtilities'
import {toDateTimeString} from '../../utilities/dateUtilities'
import stringHelpers from '../../utilities/stringHelpers'
import {ErrorModal} from '../../utilities/errorModal'
import {SuccessModal} from '../shared/successModal'
import roleUtilities from '../../utilities/roleUtilities';

function UserManagement(props) {
    const history = useHistory();
    const [invites, setInvites] = useState(null);
    const [users, setUsers] = useState(null);
    const [deleteUserId, setDeleteUserId] = useState(null);
    const [search, setSearch] = useState("");
    const [userPageNumber, setUserPageNumber] = useState(0);
    const [invitePageNumber, setInvitePageNumber] = useState(0);
    const [isLoading, setIsLoading] = useState(false)
    const [success, setSuccess] = useState(null)
    const [error, setError] = useState(null)
    const [orgAllowsApiAccess, setOrgAllowsApiAccess] = useState(false)

    var addNewUrl = "/organisation/" + props.organisationId + "/user-management/invite-user";
    var addApiUserUrl = "/organisation/" + props.organisationId + "/user-management/add-api-user";

    const changeSearchQueryTimeout = useRef();

    const changeSearchQuery = (query) => {
        setSearch(query);
        if (changeSearchQueryTimeout.current) {
            clearTimeout(changeSearchQueryTimeout.current);
            changeSearchQueryTimeout.current = null;
        }

        changeSearchQueryTimeout.current = setTimeout(() => {
            getUsers(0, query)
        }, 1000)
        
    }
    const getInvites = (page) => {
        setIsLoading(true)
        Api.getInvitations(
            (data) => {
                setInvites(data)
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            page,
            props.organisationId,
            props.token
        )
    };

    const changeUserPageNumber = function (num) {
        setUserPageNumber(num);
        getUsers(num, search)
    };

    const changeInvitePageNumber = function (num) {
        setInvitePageNumber(num);
        getInvites(num)
    };

    const getUsers = (page, query) => {
        setIsLoading(true)
        Api.getUsers(
            (data) => {
                setUsers(data)
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            query,
            page,
            100,
            props.organisationId,
            props.token
        )
    };

    const removeUser = (id) => {
        Api.removeUser(
            () => {
                setSuccess("User removed successfully")
                getUsers(userPageNumber, search)
            },
            error => {
                setError(error.errorMessage)
                console.log(error)
            },
            id, props.organisationId, props.token
        )
    };

    const resend = function (inviteId) {
        Api.resendInvitation(
            () => {
                setSuccess("Invitation email resent successfully")
                getInvites(invitePageNumber)
            },
            error => {
                setError(error.errorMessage)
                console.log(error)
            },
            inviteId,
            props.token
        )
    };

    const revoke = function (invite) {
        if (invite.isAccepted !== true && invite.isRevoked !== true) {
            Api.revokeInvitation(
                () => {
                    setSuccess('Invite Revoked Successfully')
                    getInvites(invitePageNumber)
                },
                error => {
                    setError(error.errorMessage)
                    console.log(error)
                },
                invite.id,
                props.token
            )
        }
        getInvites(invitePageNumber);
    };

    useEffect(() => {
        getInvites(0);
        getUsers(0, null);
        Api.getOrganisation((data) => {
            setOrgAllowsApiAccess(data.allowApiAccess)
        }, () => setOrgAllowsApiAccess(false), props.organisationId, props.token)
    }, [])

    return (
        <>
            {
                deleteUserId &&
                    <div className="modal fade" id="delete-user-modal" tabIndex="-1" role="dialog" aria-labelledby="On Hold Modal" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="deleteModalLabel">Are you sure you want to delete this user?</h5>
                                    <button onClick={() => setDeleteUserId(null)} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal" onClick={() => setDeleteUserId(null)}>Cancel</button>
                                    <button type="button" className="btn btn-danger btn-sm ml-2" data-dismiss="modal" onClick={() => removeUser(deleteUserId)}>
                                        Confirm</button>
                                </div>
                            </div>
                        </div>
                    </div>
            }
            {isLoading 
            ? <Loader />
            : <>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-2 col-sm-auto d-flex align-items-center pr-0">
                                            <h5 className="mb-0">User List</h5>
                                        </div>
                                        <div className="col-10 ml-auto text-right pl-0 filter-buttons-wrapper">
                                            <div className="input-group col-4 px-1">
                                        
                                                <input className="form-control form-control-sm" value={search} type="text" autoFocus={true} placeholder="search..." onChange={(e) => changeSearchQuery(e.target.value)} />
                                                
                                                <div className="input-group-append">
                                                    <button className="btn btn-falcon-default btn-sm py-0" onClick={() => {
                                                        setSearch(null)
                                                        getUsers(0, null)
                                                    }}><i className="fas fa-times"></i> Clear</button>
                                                </div>
                                            </div>
                                            <button className="btn btn-primary btn-sm ml-1" onClick={() => getUsers(userPageNumber, search) }><i className="fas fa-redo"></i> Refresh</button>
                                            {roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) && <Link className="btn btn-success btn-sm ml-1" to={addNewUrl}><i className="fas fa-plus"></i> Add</Link>}
                                            {roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) && orgAllowsApiAccess && <Link className="btn btn-success btn-sm ml-1" to={addApiUserUrl}><i className="fas fa-plus"></i> Add API User</Link>}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top">
                                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                        <thead className="bg-200 text-900">
                                            <tr>
                                                <th>Name</th>
                                                <th>Email Address</th>
                                                <th>Role</th>
                                                <th>Last Login</th>
                                                <th className="text-center">API User</th>
                                                {roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) && <th>&nbsp;</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {users && !arrayUtilities.isNullOrEmpty(users.items) && users.items.map((user) => <tr key={user.id}>
                                                <td>{user.firstName} {user.lastName}</td>
                                                <td>{user.emailAddress}</td>
                                                <td>{Enums.UserRoles[user.organisations[0].roleId]}</td>
                                                <td>{toDateTimeString(user.lastLogin)}</td>
                                                <td className="text-center">{user.allowApiAccess && <i className="fas fa-check text-success"></i>}</td>
                                                {
                                                    roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) &&
                                                    <td className="text-right">
                                                        <button onClick={() => history.push(`/organisation/${props.organisationId}/user-management/${user.id}`)} className='btn p-0'><i className="fas fa-edit mr-2 fs--1"></i></button>
                                                        <button className='btn p-0' data-toggle="modal" data-target="#delete-user-modal" onClick={() => setDeleteUserId(user.id)} ><i className="fas fa-trash-alt fs--1"></i>
                                                        </button>
                                                    </td>
                                                    
                                                }
                                            </tr>)}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="card-footer border-top ">
                                    <div className="d-flex justify-content-center row ">
                                        <div className="col-auto ">
                                            <Pagination totalResults={users?.totalCount} currentPage={userPageNumber} changePageNumber={changeUserPageNumber} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-2 col-sm-auto d-flex align-items-center pr-0">
                                            <h5 className="mb-0">Invite List</h5>
                                        </div>
                                        <div className="col-10 ml-auto text-right pl-0 filter-buttons-wrapper">
                                            <button className="btn btn-primary btn-sm ml-1" onClick={() => getInvites(invitePageNumber) }><i className="fas fa-redo"></i> Refresh</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top">
                                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                        <thead className="bg-200 text-900">
                                            <tr>
                                                <th>Email Address</th>
                                                <th>Role</th>
                                                <th>Status</th>
                                                <th className="text-center">Date Created</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invites && !arrayUtilities.isNullOrEmpty(invites.items) && invites.items.map((invite) => {
                                                var status = "Pending";
                                                if (invite.isAccepted) {
                                                    status = "Accepted";
                                                }
                                                else if (invite.isRevoked) {
                                                    status = "Revoked";
                                                }
                                                var modalId = "#modal" + invite.id;
                                                return (
                                                    <>
                                                        <tr key={invite.id}>
                                                            <td><button className="button-no-style" data-toggle="modal" data-target={modalId}>{invite.emailAddress}</button></td>
                                                            <td>{Enums.UserRoles[invite.role]}</td>
                                                            <td>{status}</td>
                                                            <td className="text-center">{toDateTimeString(invite.timestamp)}</td>
                                                        </tr>
                                                        <div className="modal fade" id={modalId.substring(1)} tabIndex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
                                                            <div className="modal-dialog" role="document">
                                                                <div className="modal-content">
                                                                    <div className="modal-header">
                                                                        <h5 className="modal-title" id="deleteModalLabel">Invite to {invite.emailAddress}</h5>
                                                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                                            <span aria-hidden="true">&times;</span>
                                                                        </button>
                                                                    </div>
                                                                    <div className="modal-body">
                                                                        <div className="row">
                                                                            <div className="col-12 ">
                                                                                <p className="font-weight-semi-bold  mt-1 mb-1">Role</p>
                                                                            </div>
                                                                            <div className="col-12">
                                                                                <div className="form-group mb-0">
                                                                                    {Enums.UserRoles[invite.role]}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-12 ">
                                                                                <p className="font-weight-semi-bold  mt-1 mb-1">Invite Status</p>
                                                                            </div>
                                                                            <div className="col-12">
                                                                                <div className="form-group mb-0">
                                                                                    {status}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row">
                                                                            <div className="col-12 ">
                                                                                <p className="font-weight-semi-bold  mt-1 mb-1">Date Created</p>
                                                                            </div>
                                                                            <div className="col-12">
                                                                                <div className="form-group mb-0">
                                                                                    {toDateTimeString(invite.timestamp)}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {status !== 'Pending' &&
                                                                            <div className="row">
                                                                                <div className="col-12 ">
                                                                                    <p className="font-weight-semi-bold  mt-1 mb-1">Status</p>
                                                                                </div>
                                                                                <div className="col-12">
                                                                                    <div className="form-group mb-0">
                                                                                        {status}
                                                                                    </div>
                                                                                </div>
                                                                            </div>}
                                                                    </div>
                                                                    <div className="modal-footer">
                                                                        <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                                                                        {status === 'Pending' && roleUtilities.isOrganisationAdminOrManager(props.user, props.organisationId) && <>
                                                                            <button type="button" className="btn btn-danger btn-sm ml-2" data-dismiss="modal" onClick={() => revoke(invite)}>Revoke Invitation</button>
                                                                            <button type="button" className="btn btn-primary btn-sm ml-2" data-dismiss="modal" onClick={() => resend(invite.id)}>
                                                                                Resend Email</button>
                                                                        </>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="card-footer border-top ">
                                    <div className="d-flex justify-content-center row ">
                                        <div className="col-auto ">
                                            <Pagination totalResults={invites?.totalCount} currentPage={invitePageNumber} changePageNumber={changeInvitePageNumber} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>}
            {!stringHelpers.isNullOrEmpty(success) && <SuccessModal message={success} onHide={() => setSuccess(null)} />}
            {!stringHelpers.isNullOrEmpty(error) && <ErrorModal message={error} onHide={() => setError(null)} />}
        </>
    )
}

export default UserManagement;